import '@app/styles.css';
import { App } from '@app/shell/app';
import { createRoot } from 'react-dom/client';

createRoot(document.getElementById('root')!).render(<App />);
